<template>
  <Header></Header>
  <router-view class="content" />
  <Footer></Footer>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import Footer from './components/Footer.vue';
import Header from './components/Header.vue';

@Options({
  components: {
    Header,
    Footer
  }
})
export default class App extends Vue {}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #9cb4ce;
}
body {
  background: #000;
}
.content {
  padding: 0px 15vw;
}

</style>
